import { DebtPaymentPlanParser } from "@/models/debtPaymentPlan/debtPaymentPlan.parser"
import { DebtPaymentPlanOptionsParser } from "@/models/debtPaymentPlanOptions/debtPaymentPlanOptions.parser"
import { AccountService } from "./AccountService"
import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { DebtPaymentPlan } from "@/models/debtPaymentPlan/debtPaymentPlan"
import { DebtPaymentPlanOptions } from "@/models/debtPaymentPlanOptions/debtPaymentPlanOptions"
import { mapQueryResult } from "@/api/utils/mapQuery"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import {
  GetPaymentPlansResponse,
  GetPaymentPlanOptionsResponse,
} from "@/api/backofficeRest/generated/model"

class DebtPaymentPlanServiceClass {
  getForAccount(accountNumber: string): QueryResult<DebtPaymentPlan[]> {
    const accountQuery = AccountService.getAccount(accountNumber)

    return useQuery({
      ...BackofficeRestQueries.paymentPlans.list(accountQuery.data?.juniferId),
      useRawResponse: true,
      placeholderData: [],
      enabled: !!accountQuery.data?.juniferId && accountQuery.isSuccess,
      parserFn: (rawData: GetPaymentPlansResponse) =>
        (rawData?.paymentPlans ?? []).map((plan) =>
          DebtPaymentPlanParser.toDomain(plan),
        ),
    })
  }

  getPlanOptionsForAccount(
    accountNumber: string,
  ): QueryResult<DebtPaymentPlanOptions | null> {
    const accountQuery = AccountService.getAccount(accountNumber)

    return useQuery({
      ...BackofficeRestQueries.paymentPlans.options(
        accountQuery.data?.juniferId,
        accountQuery.data?.id,
      ),
      useRawResponse: true,
      placeholderData: null,
      enabled: !!accountQuery.data?.juniferId && accountQuery.isSuccess,
      parserFn: (rawData: GetPaymentPlanOptionsResponse) =>
        rawData ? DebtPaymentPlanOptionsParser.toDomain(rawData) : null,
    })
  }

  activeDebtPaymentPlan(accountNumber: string) {
    return mapQueryResult(this.getForAccount(accountNumber), (query) =>
      query.data?.find((plan) => plan.isActive),
    )
  }
}

export const DebtPaymentPlanService = new DebtPaymentPlanServiceClass()
